module.exports = __webpack_public_path__ + "static/d_large-0de71e154a24d525033723e3c57479aa.jpg";